module.exports = __webpack_public_path__ + "static/media/udemy_logo.aa084a21.png";